import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=55238d90&scoped=true"
import script from "./ContactDetail.vue?vue&type=script&lang=js"
export * from "./ContactDetail.vue?vue&type=script&lang=js"
import style0 from "./ContactDetail.vue?vue&type=style&index=0&id=55238d90&prod&lang=scss&scoped=true"
import style1 from "./ContactDetail.vue?vue&type=style&index=1&id=55238d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55238d90",
  null
  
)

export default component.exports